// swiper実行
// --- 最新のswiper v11ではループ時の不具合があるため、あえてv8を使用
document.addEventListener('DOMContentLoaded', function() {

  // KVスライダー
  const sliderEl = document.querySelector('.js-front-kv-slider');
  const slidesNum = sliderEl.querySelectorAll('.swiper-slide').length;
  let count = 0;
  if (sliderEl) {
    new Swiper(sliderEl, {
      autoplay: {
        delay: 5000,
      },
      loop: true,
      effect: 'fade',
      speed: 1500,
      allowTouchMove: false,
      on: {
        slideChange: (slider) => {
          if (count < slidesNum) {
            sliderEl.querySelectorAll(`.swiper-slide.--0${slider.activeIndex}`).forEach(slide => {
              if (slider.activeIndex == 1) {
                slide.classList.add('show-elements');
              } else {
                window.setTimeout(function() {
                  slide.classList.add('show-elements');
                }, 700);
              }
            })
            count += 1;
          }
        }
      }
    });
  }

  // CASEスライダー
  if (document.querySelector('.js-case-slider')) {
    const swiper = new Swiper('.js-case-slider', {
      autoplay: {
        delay: 5000,    // スライド表示時間
      },
      loop: true,	// ループ表示
      speed: 1000,    // スライド変化時間
      slidesPerView: 1.1, // 表示スライド数
      spaceBetween: Math.floor(window.innerWidth * 0.1),   // スライド間の余白
      centeredSlides: true,    // 現在スライドを中央に配置する（初期値: false）
      breakpoints: {
        // when window width is >= 320px
        // 415: {
        //   slidesPerView: 2.5,
        //   spaceBetween: 20
        // },
        // // when window width is >= 480px
        569: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },
        // when window width is >= 640px
        769: {
          slidesPerView: 1.5,
          spaceBetween: 30
        }
      },
      pagination: {   // ページネーションの設定
        el: '.swiper-pagination',   // ページネーションラッパーのクラス
        type: 'bullets',   // ドットナビゲーション
        clickable: true,   // クリックしてスライド変更（初期値：false）
      }
    });
  }

  // MENUスライダー
  if (document.querySelector('.js-menu-slider')) {
    amplifySledesEven(document.querySelector('.js-menu-slider'), 4);
    const swiper = new Swiper('.js-menu-slider', {
      autoplay: {
        delay: 5000,    // スライド表示時間
        disableOnInteraction: false,
      },
      loop: true,	// ループ表示
      speed: 1000,    // スライド変化時間
      slidesPerView: 1, // 表示スライド数
      spaceBetween: Math.floor(window.innerWidth * 0.1),
      centeredSlides: true,    // 現在スライドを中央に配置する（初期値: false）
      navigation: {
        nextEl: ".p-front-menu__scroll",
      },
      breakpoints: {
        // when window width is >= 320px
        // 415: {
        //   slidesPerView: 2.5,
        //   spaceBetween: 20
        // },
        // // when window width is >= 480px
        569: {
          slidesPerView: 1.2,
          spaceBetween: 0,
          centeredSlides: true,    // 現在スライドを中央に配置する（初期値: false）
        },
        769: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: false,    // 現在スライドを中央に配置する（初期値: false）
        }
      },
    });

    const disableWheel = enableWheelSlide(swiper, { threshold: 40, cooldown: 500 });


    function enableWheelSlide(swiper, {
      threshold = 30,  // これ以上のスクロール量で反応（小さいと過敏）
      cooldown = 450,  // 連続発火防止(ms)
      preventDefault = true, // スライダー上ではページスクロールを止める
    } = {}) {
      const el = swiper.el;

      let acc = 0;               // スクロール量の蓄積
      let locked = false;        // クールダウン中フラグ
      let rafId = null;

      const onWheel = (e) => {
        // Swiperが破棄済みなら何もしない
        if (swiper.destroyed) return;

        // スライダー上でだけ反応
        // （もし「子要素の上でも反応してほしい」ならこのままでOK）
        // 既に el に listener を付けてるので範囲は自然に限定されます

        // 斜めスクロール/横スクロール対策：縦成分が優勢な時だけ
        const dy = e.deltaY;
        const dx = e.deltaX;
        if (Math.abs(dy) < Math.abs(dx)) return;

        if (preventDefault) {
          // passive: false が必須（下で指定）
          e.preventDefault();
        }

        if (locked) return;

        acc += dy;

        // requestAnimationFrameで評価（タッチパッドの細かい連続入力に強い）
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;

          if (Math.abs(acc) < threshold) return;

          locked = true;
          const dir = acc > 0 ? "next" : "prev";
          acc = 0;

          if (dir === "next") swiper.slideNext();
          else swiper.slidePrev();

          window.setTimeout(() => {
            locked = false;
          }, cooldown);
        });
      };

      // passive:false じゃないと preventDefault が効かない
      el.addEventListener("wheel", onWheel, { passive: false });

      // 解除用関数を返す
      return () => {
        el.removeEventListener("wheel", onWheel);
      };
    }


  }

  function amplifySledesEven(slider, num) {
    const wrapper =  slider.querySelector('.swiper-wrapper');
    let slideNum = wrapper.querySelectorAll('.swiper-slide').length;
    const cloneArray = [];
    while (slideNum < num || slideNum % 2 !== 0) {
      if (cloneArray.length === 0) {
        wrapper.querySelectorAll('.swiper-slide').forEach(slide => {
          cloneArray.push(slide.cloneNode(true));
        });
      }
      for (let clone of cloneArray) {
        wrapper.append(clone);
      }
      slideNum = wrapper.querySelectorAll('.swiper-slide').length;
    }
  }
  function amplifySledes(slider, num) {
    const slides = slider.querySelectorAll('.swiper-slide');
    if (slides.length < num) {
      const cloneArray = [];
      slides.forEach(slide => {
          cloneArray.push(slide.cloneNode(true));
      });
      const loopCount = Math.floor(num / slides.length);
      const wrapper = slider.querySelector('.swiper-wrapper');
      for (let i = 0; i < loopCount; i++) {
        for (let clone of cloneArray) {
          wrapper.append(clone);
        }
      }
    }
  }

  // swiper PC3つ並び / TB2つ並び / SP1つ
  // const swiper = new Swiper(".js-swiper .swiper", {
  //   speed: 1000,
  //   loop: true,
  //   autoplay: {
  //     delay: 2000,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1,
  //   spaceBetween: 0,

  //   // ブレークポイント（画面幅による設定）
  //   breakpoints: {
  //     // 画面幅が 768px 以上の場合（window width >= 768px）
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 20
  //     },
  //     // 画面幅が 1024px 以上の場合（window width >= 1024px）
  //     1024: {
  //       slidesPerView: 3,
  //       spaceBetween: 40
  //     }
  //   },
  //   pagination: {
  //     el: ".js-swiper .swiper-pagination",
  //   },
  //   navigation: {
  //     nextEl: ".js-swiper .swiper-button-next",
  //     prevEl: ".js-swiper .swiper-button-prev",
  //   },
  // });


  // // swiper 自動再生
  // const swiper = new Swiper(".js-swiper .swiper", {
  //   loop: true,
  //   speed: 5000,
  //   autoplay: {
  //     delay: 0,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1.5,
  //   spaceBetween: 10,

  //   // ブレークポイント（画面幅による設定）
  //   breakpoints: {
  //     // 画面幅が 768px 以上の場合（window width >= 768px）
  //     768: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 20
  //     },
  //     // 画面幅が 1024px 以上の場合（window width >= 1024px）
  //     1024: {
  //       slidesPerView: 3.5,
  //       spaceBetween: 30
  //     }
  //   },
  // });


  // // swiper サムネイルと連動するスライダー
  // // サムネイル
  // const swiper_thumb = new Swiper('.js-swiper__thumb', {
  //   slidesPerView: 4,
  //   spaceBetween: 30,
  //   freeMode: true,
  //   slideToClickedSlide: true,
  //   watchSlidesVisibility: true,
  //   watchSlidesProgress: true,
  // })

  // // メインスライダー
  // const swiper_main = new Swiper('.js-swiper__main', {
  //   speed: 1000,
  //   autoplay: {
  //     delay: 3000,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1,
  //   loop: true,
  //   loopedSlides: 6,
  //   centeredSlides: true,
  //   disableOnInteraction: true,
  //   navigation: {
  //     nextEl: '.js-swiper .swiper-button-next',
  //     prevEl: '.js-swiper .swiper-button-prev',
  //   },
  //   thumbs: {
  //     swiper: swiper_thumb,
  //   },
  // })



})


window.addEventListener('DOMContentLoaded',function(){

  function initVoiceSwiper() {
    const swiperEl = document.querySelector(".js-voice-swiper");
    if(!swiperEl) return;

    let voiceSwiper = null;
    const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
    const isSP = window.innerWidth <= 769;

    const shouldInit = isSP ? slideCount > 2 : slideCount > 3;

    // 既にSwiperがある場合は一旦破棄
    if (voiceSwiper) {
      voiceSwiper.destroy(true, true);
      voiceSwiper = null;
    }

    if (shouldInit) {
      swiperEl.classList.remove('no-slide');

      voiceSwiper = new Swiper(".js-voice-swiper", {
        speed: 5000,
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: "auto",
        spaceBetween: 20,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        breakpoints: {
          769: {
            spaceBetween: 40
          }
        }
      });

    } else {
      swiperEl.classList.add('no-slide');
    }
  }
  // 初期実行
  initVoiceSwiper();
  // resizeで再判定（軽くdebounce）
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initVoiceSwiper();
    }, 200);
  });
})
